<template>
  <div class="animated fadeIn pt3 pb4">
    <div class="clearfix gibson px2 mb2">
      <!-- mobile setup -->
      <div class="col-12 px2" v-if="showMobile">
        <div class="clearfix border muted-border p2 py3 mb2 shadow">
          <!-- header text and list - mobile -->
          <div class="col-12 px2">
            <p class="h2 semi-bold line-height-2 mt2 mb1 gibson darkblue">For meget at lave?</p>
            <p class="h5 gibson line-height-3 darkblue regular">– Søg arbejdskraft</p>
            <ul class="list-reset pl0 ml0 mt3">
              <li class="flex justify-start items-center mb2">
                <span class="mr2">
                  <img class="block fit" width="24" src="static/img/sky-blue-checkmark.png">
                </span>
                <p class="h5 gibson line-height-1 m0 p0 darkblue regular">Find kvalificeret arbejdskraft</p>
              </li>
              <li class="flex justify-start items-center mb2">
                <span class="mr2">
                  <img class="block fit" width="24" src="static/img/sky-blue-checkmark.png">
                </span>
                <p class="h5 gibson line-height-1 m0 p0 darkblue regular">Sig ja til større opgaver</p>
              </li>
              <li class="flex justify-start items-center mb2">
                <span class="mr2">
                  <img class="block fit" width="24" src="static/img/sky-blue-checkmark.png">
                </span>
                <p class="h5 gibson line-height-1 m0 p0 darkblue regular">Håndtèr flere opgaver</p>
              </li>
            </ul>
            <!-- text - mobile -->
            <p class="h5 regular darkblue line-height-golden mb1 gibson">
              Mangler du ekstra hænder, kan du med Mester til Mester øge din arbejdsstyrke i en kortere eller længere periode.
              <span id="dots">...</span>
              <br><br>
              <span id="more">
                <span class="semi-bold">Sig ja til større opgaver</span>
                <br>
                Du kan takke ja til større opgaver, da du nemt kan indhente ekstra kvalificeret arbejdskraft i den periode, hvor opgaven skal udføres.
                <br><br>
                <span class="semi-bold">Håndtér flere opgaver</span>
                <br>
                Undgå at sige nej til faste kunder, fordi du har taget en større opgave ind. Du kan nemt indhente arbejdskraft til at varetage alle dine opgaver og behøver ikke at gå på kompromis. Med Mester til Mester kan du udvide dit arbejdsområde og samtidig pleje dine loyale kunder.
              </span>
            </p>
            <!-- readmore button -->
            <div @click="readMore()" id="moreBtn" class="clearfix">
              <div class="col-12 px0 flex flex-column justify-center items-center">
                <div class="border green-border shadow green center" style="height:32px;width:32px;border-radius:50%;line-height:32px;border-width:2px!important;">
                  <span id="moreIcon">
                    <i class="el-icon-bottom" style="font-weight:700;font-size:16px;"></i>
                  </span>
                  <span id="lessIcon" style="display:none;">
                    <i class="el-icon-top" style="font-weight:700;font-size:16px;"></i>
                  </span>
                </div>
                <p id="btnText" class="block center green h6 gibson line-height-1 mt1 mb0">Læs mere</p>
              </div>
            </div>
            <!-- filter - mobile - hidden -->
            <div class="col-12 px0 flex justify-start items-center my2 hide">
              <button v-b-toggle.reservedJobs class="col-12 p2 gibson outlined-primary-button not-rounded flex justify-center items-center">
                <span class="h4 mb0 mr2">Se reserverede jobs</span>
                <span class="flex-none when-closed">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                  </span>
                </span>
                <span class="flex-none when-opened">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                  </span>
                </span>
              </button>
            </div>
            <!-- filter - mobile - hidden -->
            <div class="col-12 px0 flex justify-start items-center my2 hide">
              <button v-b-toggle.workDetails class="col-12 p2 gibson outlined-primary-button not-rounded flex justify-center items-center">
                <span class="h4 mb0">Filter</span>
                <span class="relative ml2" style="top:4px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                </span>
              </button>
            </div>
            <!-- create job / see jobs - mobile - buttons -->
            <div class="col-12 px0 flex flex-column mt4 mb2">
              <button  @click="getdataigibility('no')" v-b-toggle.createItem id="setOpgave" class="p2 gibson outlined-primary-button not-rounded flex justify-center items-center">
                <span class="h5 mb0">Opslå din opgave</span>
                <span class="ml2"><i class="el-icon-right"></i></span>
              </button>
              <div class="py1"></div>
              <button @click="OpenUrl('/markedsplads?mode=mester')" id="seeAvailableJobs" class="p2 gibson primary-button not-rounded flex justify-center items-center">
                <span class="h5 mb0">Se opgaver</span>
                <span class="ml2"><i class="el-icon-right"></i></span>
              </button>
            </div>
            <b-collapse id="createItem">
              <form>
                <div class="clearfi mt3 mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Vælg opgavetype
                  </p>
                  <v-select v-model="opgave1" :options="opgaveoptions" @changed="change1" required class="p1 muted-background darkblue gibson h6 regular border-none not-rounded">
                    <template slot="no-options">
                      Ingen matchende ...
                    </template>
                  </v-select>
                  <div class="text-danger" v-if="validationErrors.opgave1 && opgave1 === ''">
                    Nødvendig
                  </div>
                </div>
                <div class="clearfi mb3" v-if="opgaverhow">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Yderligere information
                  </p>
                  <v-select v-model="subopgave1" :options="subopgaveoptions" required class="col-12 p1 muted-background darkblue gibson h6 regular border-none not-rounded">
                    <template slot="no-options">
                      Ingen matchende ...
                    </template>
                  </v-select>
                  <div class="text-danger" v-if="validationErrors.opgave1 && opgave1 === ''" >Nødvendig</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Forventet bemanding
                  </p>
                  <input type="number" v-model="numofman1" class="p2 muted-background darkblue h6 gibson border-none not-rounded col-12">
                  <div class="text-danger" v-if="validationErrors.numofman1 && numofman1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Antal tilbud på opgaven
                  </p>
                  <select v-model="offer1" class="muted-background col-12 h6 darkblue p2 regular outline-none border-none gibson not-rounded">
                    <option value='3' selected>3 Tilbud</option>
                    <option value='2'>2 Tilbud</option>
                    <option value='1'>1 Tilbud</option>
                  </select>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Postnummer for opgaven
                  </p>
                  <input type="number" v-model="postnumber1" class="p2 muted-background darkblue h5 gibson border-none not-rounded col-12" placeholder="">
                  <div class="text-danger" v-if="validationErrors.postnumber1 && postnumber1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Opstartsdato
                  </p>
                  <date-picker id="ferieStart" type="text" required v-model="startdate1" :config="config" required class="muted-background gibson border-none not-rounded"></date-picker>
                  <div class="text-danger" v-if="validationErrors.startdate1 && startdate1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Varighed
                  </p>
                  <select name="duration1" id="duration1" v-model="duration1" class="muted-background col-12 h6 gibson darkblue p2 outline-none border-none">
                    <option value="" selected="selected">Vælg</option>
                    <option value="1t">1 timer</option>
                    <option value="2t">2 timer</option>
                    <option value="3t">3 timer</option>
                    <option value="4t">4 timer</option>
                    <option value="5t">5 timer</option>
                    <option value="6t">6 timer</option>
                    <option value="1d">1 dag</option>
                    <option value="2d">2 dage</option>
                    <option value="3d">3 dage</option>
                    <option value="4d">4 dage</option>
                    <option value="5d">5 dage</option>
                    <option value="6d">6 dage</option>
                    <option value="7d">7 dage</option>
                    <option value="8d">8 dage</option>
                    <option value="9d">9 dage</option>
                    <option value="10d">10 dage</option>
                    <option value="11d">11 dage</option>
                    <option value="12d">12 dage</option>
                    <option value="13d">13 dage</option>
                    <option value="14d">14 dage</option>
                    <option value="15d">15 dage</option>
                    <option value="16d">Over 15 dage</option>
                  </select>
                  <div class="text-danger" v-if="validationErrors.duration1 && duration1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Forventet budget (ex. moms)
                  </p>
                  <input type="text" v-model="timepris1" class="p2 muted-background darkblue h5 gibson border-none not-rounded col-12" placeholder="">
                  <div class="text-danger" v-if="validationErrors.timepris1 && timepris1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Beskrivelse
                  </p>
                  <textarea v-model="desc1" class="p2 col-12 muted-background h5 line-height-golden darkblue gibson not-rounded border-none" style="min-height:120px;" placeholder=""></textarea>
                  <div class="text-danger" v-if="validationErrors.desc1 && desc1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Billeder
                  </p>
                  <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
                  <div v-for="image in images" :key="image">
                    <div class="px2 flex flex-column justify-center items-center mb2">
                      <img :src="image" alt="" class="fit mb2" style="width:100px;height:100px;">
                      <button  @click="delete_image(image)" class="outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt"><path d='M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z'/></svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Dokument
                  </p>
                  <dropzone id="myVueDropzone2" :options="dropzoneOptions2" v-on:vdropzone-success="showSuccess2" v-on:vdropzone-sending="sendingEvent"></dropzone>
                  <div v-for="file in files" :key="file">
                    <div class="px2 flex flex-column justify-center items-center mb2">
                      {{ RemoveUrl(file) }}
                      <button  @click="delete_file(file)" class="outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt"><path d='M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z'/></svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="clearfix mb3">
                  <button type="button" @click="getdataigibility('yes')" class="col-12 action-button p2 gibson h5 flex justify-center items-center">
                    <span class="semi-bold">Fortsæt</span>
                    <span class="ml2">
                      <i class="el-icon-right"></i>
                    </span>
                  </button>
                </div>
              </form>
            </b-collapse>
          </div>
        </div>
        <!-- single items setup - mohile -->
        <div class="clearfix border muted-border p2 pb3 mt2">
          <template v-for="item in opgaver">
            <button :key="item.id" v-b-toggle="'workDetails'+item.id" class="col-12 p2 primary-white-button not-rounded border-none gibson flex justify-start items-start mb1">
              <div>
                <svg fill="currentColor" width="48" height="48" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"/><path d="M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"/><path d="M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"/></svg>
              </div>
              <div class="flex-auto pl2">
                <p class="darkblue mb0 line-height-1 left-align">
                  <span class="h3 regular block mb1">{{item.productname}}</span>
                  <span class="h5 regular">Startdato:<br>{{ moment(item.startdate1).locale('da').format('LL') }}</span>
                </p>
              </div>
              <div class="when-closed">
                <span>
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                </span>
              </div>
              <div class="flex-none when-opened">
                <span>
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                </span>
              </div>
            </button>
            <div class="float-right pr3" >
              <b-button variant="outline-danger" @click="aflyseOpgave(item.id)" size="sm">Slet</b-button>
            </div>
            <!-- product name - mobile -->
            <div :key="item.id" class="px2 flex flex-wrap">
              <div class="py1 h4 darkblue gibson">
                {{ item.productname2 }}
              </div>
            </div>
            <!-- number of offers - mobile -->
            <div :key="item.id" class="px2">
              <p class="darkblue-background white h4 regular center line-height-golden mb0 gibson p2">
                <span class="semi-bold">{{ item.reserve }}</span> ud af <span class="semi-bold">{{ item.offer1 }}</span> tilbud
              </p>
            </div>
            <div :key="item.id" class="col-12 px2" v-if="item.pidlist.length !== 0">
              <div class="table-responsive" striped bordered>
                <table class="table">
                  <thead>
                    <tr>
                      <th>
                        <span class="h6 regular line-height-1 m0">Firma</span>
                      </th>
                      <th>
                        <span class="h6 regular line-height-1 m0">Navn</span>
                      </th>
                      <th>
                        <span class="h6 regular line-height-1 m0">Mobile</span>
                      </th>
                      <th>
                        <span class="h6 regular line-height-1 m0">Email</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="pidl in item.pidlist">
                      <td>
                        <span class="h6 regular line-height-1 m0" >{{pidl.company}}</span>
                      </td>
                      <td>
                        <span class="h6 regular line-height-1 m0" >{{pidl.name}}</span>
                      </td>
                      <td>
                        <span class="h6 regular line-height-1 m0" ><a :href="'tel:'+pidl.mobile" >{{pidl.mobile}}</a></span>
                      </td>
                      <td>
                        <span class="h6 regular line-height-1 m0" ><a :href="'mail::'+pidl.email">{{pidl.email}}</a></span>
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div :key="item.id" class="px2 my2 hide">
              <select class="col-12 white-background darkblue not-rounded border muted-border shadow gibson mb0 h6 flex justify-center items-center p2" style="height:inherit;font-size:1.25rem!important;">
                <option value="Select status" selected>Select status</option>
                <option value="I dialog">I dialog</option>
                <option value="Vandt opgaven">Vandt opgaven</option>
              </select>
            </div>
            <!-- job item details collapse - mobile -->
            <b-collapse :key="item.id" :id="'workDetails' + item.id">
              <div class="clearfix px2 darkblue gibson">
                <div class="col-12 px0 mt2">
                  <!-- job item details - mobile -->
                  <div class="flex justify-between items-center">
                    <p class="h6 semi-bold darkblue gibson line-height-3 mb2">
                      <span class="block semi-bold">Forventet bemanding</span>
                      <span class="h4 regular">{{ item.numofman1 }} mænd</span>
                    </p>
                    <p class="h6 semi-bold darkblue gibson line-height-3">
                      <span class="block semi-bold">Varighed</span>
                      <span class="h4 regular">{{ item.duration1 }} </span>
                    </p>
                  </div>
                  <div class="mb2">
                    <p class="h6 semi-bold darkblue gibson line-height-3">
                      <span class="block semi-bold">Forventet budget (ex. moms)</span>
                      <span class="h4 regular">{{ item.timepris1 }}&nbsp; </span>
                    </p>
                  </div>
                  <div class="mb2">
                    <p class="h6 semi-bold darkblue gibson line-height-3">
                      <span class="block semi-bold">Postnummer</span>
                      <span class="regular h4">{{ item.postnumber1 }} </span>
                    </p>
                  </div>
                  <!-- description - mobile -->
                  <div class="mb2">
                    <p class="h6 semi-bold darkblue gibson line-height-3">
                      <span class="block semi-bold">Beskrivelse</span>
                      <span class="h4 regular">{{ item.desc1 }} </span>
                    </p>
                  </div>
                  <!-- imagelist - mobile  -->
                  <div class="mb2">
                    <p class="h6 semi-bold darkblue gibson line-height-3">
                      <span class="block semi-bold">Billeder</span>
                    </p>
                    <div class="col-12 flex flex-column">
                      <div class="mb2" v-for="image in item.imagelist" :key="image">
                        <img :src="image" alt="" class="block fit cover">
                      </div>
                    </div>
                  </div>
                  <!-- filelist - mobile -->
                  <div class="mb2">
                    <p class="h6 semi-bold darkblue gibson line-height-3">
                      <span class="block semi-bold">Filer</span>
                    </p>
                    <div v-for="file in item.filelist" :key="file">
                      <div class="mb2">
                        <span class="primarycolor el-icon-paperclip"></span>
                        <a :href="file" alt="">{{RemoveUrl(file)|truncate(30,'...')}}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </template>
        </div>
        <div class="py2"></div>
        <div class="py4"></div>
      </div>
      <!-- desktop setup -->
      <div class="clearfix px2 ml4" v-if="!showMobile">
        <div class="col-12 p2 py3 mb2">
          <div class="clearfix px2">
            <!-- header text and list -->
            <p class="h2 semi-bold line-height-2 mt2 mb1 gibson darkblue">For meget at lave?</p>
            <p class="h5 gibson line-height-3 darkblue regular">– Søg arbejdskraft</p>
            <ul class="list-reset pl0 ml0 mt3">
              <li class="flex justify-start items-center mb2">
                <span class="mr2">
                  <img class="block fit" width="24" src="static/img/sky-blue-checkmark.png">
                </span>
                <p class="h5 gibson line-height-1 m0 p0 darkblue regular">Find kvalificeret arbejdskraft</p>
              </li>
              <li class="flex justify-start items-center mb2">
                <span class="mr2">
                  <img class="block fit" width="24" src="static/img/sky-blue-checkmark.png">
                </span>
                <p class="h5 gibson line-height-1 m0 p0 darkblue regular">Sig ja til større opgaver</p>
              </li>
              <li class="flex justify-start items-center mb2">
                <span class="mr2">
                  <img class="block fit" width="24" src="static/img/sky-blue-checkmark.png">
                </span>
                <p class="h5 gibson line-height-1 m0 p0 darkblue regular">Håndtèr flere opgaver</p>
              </li>
            </ul>
            <!-- text -->
            <div class="col-7 px0 mt3">
              <p class="h5 regular darkblue line-height-golden mb1 gibson">
              Mangler du ekstra hænder, kan du med Mester til Mester øge din arbejdsstyrke i en kortere eller længere periode.
                <span id="dots">...</span>
                <br><br>
                <span id="more">
                  <span class="semi-bold">Sig ja til større opgaver</span>
                  <br>
                  Du kan takke ja til større opgaver, da du nemt kan indhente ekstra kvalificeret arbejdskraft i den periode, hvor opgaven skal udføres.
                  <br><br>
                  <span class="semi-bold">Håndtér flere opgaver</span>
                  <br>
                  Undgå at sige nej til faste kunder, fordi du har taget en større opgave ind. Du kan nemt indhente arbejdskraft til at varetage alle dine opgaver og behøver ikke at gå på kompromis. Med Mester til Mester kan du udvide dit arbejdsområde og samtidig pleje dine loyale kunder.
                </span>
              </p>
            </div>
            <!-- readmore button -->
            <div @click="readMore()" id="moreBtn" class="clearfix">
              <div class="col-7 px0 flex flex-column justify-center items-center">
                <div class="border green-border shadow green center" style="height:48px;width:48px;border-radius:50%;line-height:48px;border-width:2px!important;">
                  <span id="moreIcon">
                    <i class="el-icon-bottom" style="font-weight:700;font-size:24px;"></i>
                  </span>
                  <span id="lessIcon" style="display:none;">
                    <i class="el-icon-top" style="font-weight:700;font-size:24px;"></i>
                  </span>
                </div>
                <p id="btnText" class="block center green h6 gibson line-height-1 mt1 mb0">Læs mere</p>
              </div>
            </div>
            <!-- reserved jobs button -->
            <div class="col-12 px0 flex justify-start items-center my2 hide">
              <button v-b-toggle.reservedJobs class="col-12 p2 gibson outlined-primary-button not-rounded flex justify-center items-center">
                <span class="h4 mb0 mr2">Se reserverede jobs</span>
                <span class="flex-none when-closed">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                  </span>
                </span>
                <span class="flex-none when-opened">
                  <span class="relative" style="top:3px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                  </span>
                </span>
              </button>
            </div>
            <!-- filter button -->
            <div class="col-7 px0 flex justify-between items-center my2 hide">
              <button v-b-toggle.workDetails class="col-12 p2 gibson outlined-primary-button not-rounded flex justify-center items-center">
                <span class="h4 mb0">Filter</span>
                <span class="relative ml2" style="top:4px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                </span>
              </button>
            </div>
            <!-- create job / view jobs -->
            <div class="col-7 px0 flex justify-between items-center mt4">
              <button  @click="getdataigibility('no')" v-b-toggle.createItem id="setOpgave" class="h5 regular p2 gibson outlined-primary-button not-rounded flex justify-center items-center">
                <span>Opslå din opgave</span>
                <span class="ml1"><i class="el-icon-right"></i></span>
              </button>
              <button @click="OpenUrl('/markedsplads?mode=mester')" id="seeOpgaver" class="h5 regular p2 gibson outlined-primary-button not-rounded flex justify-center items-center">
                <span>Se opgaver</span>
                <span class="ml1"><i class="el-icon-right"></i></span>
              </button>
            </div>
            <!-- create job form in collapse -->
            <b-collapse id="createItem" class="col-7 px0">
              <form>
                <div class="clearfix mt3 mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Vælg opgavetype
                  </p>
                  <v-select v-model="opgave1" :options="opgaveoptions" @changed="change1" required class="p1 muted-background darkblue gibson h6 regular border-none not-rounded">
                    <template slot="no-options">
                      Ingen matchende ...
                    </template>
                  </v-select>
                  <div class="text-danger" v-if="validationErrors.opgave1 && opgave1 === ''">
                    Nødvendig
                  </div>
                </div>
                <div class="clearfi mb3" v-if="opgaverhow">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Yderligere information
                  </p>
                  <v-select v-model="subopgave1" :options="subopgaveoptions" required class="col-12 p1 muted-background darkblue gibson h6 regular border-none not-rounded">
                    <template slot="no-options">
                      Ingen matchende ...
                    </template>
                  </v-select>
                  <div class="text-danger" v-if="validationErrors.opgave1 && opgave1 === ''" >Nødvendig</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Forventet bemanding
                  </p>
                  <input type="number" v-model="numofman1" class="p2 muted-background darkblue h6 gibson border-none not-rounded col-12">
                  <div class="text-danger" v-if="validationErrors.numofman1 && numofman1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Antal tilbud på opgaven
                  </p>
                  <select v-model="offer1" class="muted-background col-12 h6 darkblue p2 regular outline-none border-none gibson not-rounded">
                    <option value='3' selected>3 Tilbud</option>
                    <option value='2'>2 Tilbud</option>
                    <option value='1'>1 Tilbud</option>
                  </select>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Postnummer for opgaven
                  </p>
                  <input type="number" v-model="postnumber1" class="p2 muted-background darkblue h5 gibson border-none not-rounded col-12" placeholder="">
                  <div class="text-danger" v-if="validationErrors.postnumber1 && postnumber1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Opstartsdato
                  </p>
                  <date-picker id="ferieStart" type="text" required v-model="startdate1" :config="config" required class="muted-background gibson border-none not-rounded"></date-picker>
                  <div class="text-danger" v-if="validationErrors.startdate1 && startdate1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Varighed
                  </p>
                  <select name="duration1" id="duration1" v-model="duration1" class="muted-background col-12 h6 gibson darkblue p2 outline-none border-none">
                    <option value="" selected="selected">Vælg</option>
                    <option value="1t">1 timer</option>
                    <option value="2t">2 timer</option>
                    <option value="3t">3 timer</option>
                    <option value="4t">4 timer</option>
                    <option value="5t">5 timer</option>
                    <option value="6t">6 timer</option>
                    <option value="1d">1 dag</option>
                    <option value="2d">2 dage</option>
                    <option value="3d">3 dage</option>
                    <option value="4d">4 dage</option>
                    <option value="5d">5 dage</option>
                    <option value="6d">6 dage</option>
                    <option value="7d">7 dage</option>
                    <option value="8d">8 dage</option>
                    <option value="9d">9 dage</option>
                    <option value="10d">10 dage</option>
                    <option value="11d">11 dage</option>
                    <option value="12d">12 dage</option>
                    <option value="13d">13 dage</option>
                    <option value="14d">14 dage</option>
                    <option value="15d">15 dage</option>
                    <option value="16d">Over 15 dage</option>
                  </select>
                  <div class="text-danger" v-if="validationErrors.duration1 && duration1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Forventet budget (ex. moms)
                  </p>
                  <input type="text" v-model="timepris1" class="p2 muted-background darkblue h5 gibson border-none not-rounded col-12" placeholder="">
                  <div class="text-danger" v-if="validationErrors.timepris1 && timepris1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Beskrivelse
                  </p>
                  <textarea v-model="desc1" class="p2 col-12 muted-background h5 line-height-golden darkblue gibson not-rounded border-none" style="min-height:120px;" placeholder=""></textarea>
                  <div class="text-danger" v-if="validationErrors.desc1 && desc1 === ''" >Nødvendig .</div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Billeder
                  </p>
                  <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess" v-on:vdropzone-sending="sendingEvent"></dropzone>
                  <div v-for="image in images" :key="image">
                    <div class="px2 flex flex-column justify-center items-center mb2">
                      <img :src="image" alt="" class="fit mb2" style="width:100px;height:100px;">
                      <button  @click="delete_image(image)" class="outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt"><path d='M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z'/></svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="clearfix mb3">
                  <p class="h6 regular darkblue gibson line-height-1 mb1">
                    Dokument
                  </p>
                  <dropzone id="myVueDropzone2" :options="dropzoneOptions2" v-on:vdropzone-success="showSuccess2" v-on:vdropzone-sending="sendingEvent"></dropzone>
                  <div v-for="file in files" :key="file">
                    <div class="px2 flex flex-column justify-center items-center mb2">
                      {{ RemoveUrl(file) }}
                      <button  @click="delete_file(file)" class="outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash-alt"><path d='M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z'/></svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="clearfix mb3">
                  <button type="button" @click="getdataigibility()" class="action-button p2 gibson h5 flex justify-center items-center">
                    <span class="semi-bold">Fortsæt</span>
                    <span class="ml2">
                      <i class="el-icon-right"></i>
                    </span>
                  </button>
                </div>
              </form>
            </b-collapse>
          </div>
        </div>
        <div class="col-12 px2">
          <template>
            <div class="ml4" v-if="!opgaver.length"></div>
            <div v-else>
              <div class="flex flex-wrap mt2 ml2">
                <!-- single job item setup - desktop -->
                <div class="col-4 border muted-border shadow px1 py2 pb3 mr2" v-for="item in opgaver" :key="item.id">
                  <button v-b-toggle="'workDetails'+item.id" class="col-12 py2 primary-white-button not-rounded border-none gibson flex justify-start items-start mb1">
                    <div>
                      <svg fill="currentColor" width="48" height="48" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"/><path d="M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"/><path d="M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"/></svg>
                    </div>
                    <div class="flex-auto pl2">
                      <!-- single job item - name and date -->
                      <p class="darkblue mb0 line-height-1 left-align">
                        <span class="h4 regular block" style="margin-bottom:6px;">{{item.productname}}</span>
                        <span class="h6 regular">Startdato:<br>{{ moment(item.startdate1).locale('da').format('LL') }}</span>
                      </p>
                    </div>
                    <!-- chevron toggle -->
                    <div class="when-closed">
                      <span class="relative">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                      </span>
                    </div>
                    <div class="flex-none when-opened">
                      <span class="relative">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                      </span>
                    </div>
                  </button>
                  <div class="float-right pr3" >
                    <b-button variant="outline-danger" @click="aflyseOpgave(item.id)" size="sm">Slet</b-button>
                  </div>
                  <!-- product name -->
                  <div class="px2 flex flex-wrap">
                    <div class="py1 h5 regular darkblue gibson">
                      {{ item.productname2 }}
                    </div>
                  </div>
                  <!-- number of offers -->
                  <div class="px2">
                    <p class="darkblue-background white h5 regular center line-height-golden mb0 gibson p2">
                      <span class="semi-bold">{{ item.reserve }}</span> ud af <span class="semi-bold">{{ item.offer1 }}</span> tilbud
                    </p>
                  </div>
                  <div class="col-12 px2" v-if="item.pidlist.length !== 0">
                    <div class="table-responsive" striped bordered>
                      <table class="table">
                        <thead>
                          <tr>
                            <th>
                              <span class="h6 regular line-height-1 m0">Firma</span>
                            </th>
                            <th>
                              <span class="h6 regular line-height-1 m0">Navn</span>
                            </th>
                            <th>
                              <span class="h6 regular line-height-1 m0">Mobile</span>
                            </th>
                            <th>
                              <span class="h6 regular line-height-1 m0">Email</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="pidl in item.pidlist">
                            <td>
                              <span class="h6 regular line-height-1 m0" >{{pidl.company}}</span>
                            </td>
                            <td>
                              <span class="h6 regular line-height-1 m0" >{{pidl.name}}</span>
                            </td>
                            <td>
                              <span class="h6 regular line-height-1 m0" ><a :href="'tel:'+pidl.mobile" >{{pidl.mobile}}</a></span>
                            </td>
                            <td>
                              <span class="h6 regular line-height-1 m0" ><a :href="'mail::'+pidl.email">{{pidl.email}}</a></span>
                            </td>

                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="px2 my2 hide">
                    <select class="col-12 white-background darkblue not-rounded border muted-border shadow gibson mb0 h6 flex justify-center items-center p2" style="height:inherit;font-size:1.25rem!important;">
                      <option value="Select status" selected>Select status</option>
                      <option value="I dialog">I dialog</option>
                      <option value="Vandt opgaven">Vandt opgaven</option>
                    </select>
                  </div>
                  <!-- single job item collapse -->
                  <b-collapse :id="'workDetails' + item.id">
                    <!-- single job item details in collapse -->
                    <div class="clearfix px2 darkblue gibson">
                      <div class="col-12 px0 mt2">
                        <div class="flex flex-column">
                          <p class="h6 semi-bold darkblue gibson line-height-3 mb2">
                            <span class="block semi-bold">Forventet bemanding</span>
                            <span class="h5 regular">{{ item.numofman1 }} mænd</span>
                          </p>
                          <p class="h6 semi-bold darkblue gibson line-height-3">
                            <span class="block semi-bold">Varighed</span>
                            <span class="h5 regular">{{ item.duration1 }} </span>
                          </p>
                        </div>
                        <div class="mb2">
                          <p class="h6 semi-bold darkblue gibson line-height-3">
                            <span class="block semi-bold">Forventet budget (ex. moms)</span>
                            <span class="h5 regular">{{ item.timepris1 }}&nbsp; </span>
                          </p>
                        </div>
                        <div class="mb2">
                          <p class="h6 semi-bold darkblue gibson line-height-3">
                            <span class="block semi-bold">Postnummer</span>
                            <span class="regular h5">{{ item.postnumber1 }} </span>
                          </p>
                        </div>
                        <div class="mb2">
                          <p class="h6 semi-bold darkblue gibson line-height-3">
                            <span class="block semi-bold">Beskrivelse</span>
                            <span class="h5 regular">{{ item.desc1 }} </span>
                          </p>
                        </div>
                        <!-- imagelist - desktop -->
                        <div class="mb2">
                          <p class="h6 semi-bold darkblue gibson line-height-3">
                            <span class="block semi-bold">Billeder</span>
                          </p>
                          <div class="flex flex-wrap justify-between">
                            <div class="col-6 p1" v-for="image in item.imagelist" :key="image">
                              <img :src="image" alt="" class="block fit cover">
                            </div>
                          </div>
                        </div>
                        <!-- filelist - desktop -->
                        <div class="mb2">
                          <p class="h6 semi-bold darkblue gibson line-height-3">
                            <span class="block semi-bold">Filer</span>
                          </p>
                          <div v-for="file in item.filelist" :key="file">
                            <div class="mb2">
                              <span class="primarycolor el-icon-paperclip"></span>
                              <a :href="file" alt="">{{RemoveUrl(file)|truncate(20,'...')}}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <noneligibleFeaturepop ref="noneligibleFeaturepop"></noneligibleFeaturepop>
  </div>
</template>
<script>
// import hotlinemodal from './modals/HotlineModal'
// import archivemodal from './modals/ArchiveModal'
import Haandvaerker from './haandvaerker'
// import { BFormDatepicker } from 'bootstrap-vue'
// Vue.component('b-form-datepicker', BFormDatepicker)
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
// import Imentor from './imentor'
// import { VFBLogin as VFacebookLogin } from 'vue-facebook-login-component'
import vSelect from 'vue-select'
import Dropzone from 'vue2-dropzone'
import datePicker from 'vue-bootstrap-datetimepicker'
import noneligibleFeaturepop from './noneligibleFeaturepop'
export default {
  name: 'Mester',
  data () {
    return {
      dropzoneOptions: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 17,
        acceptedFiles: 'image/*',
        createImageThumbnails: true,
        addRemoveLinks: true,
        renameFile: true,
        complete: function (file) {
          setTimeout(() => {
            this.removeFile(file)
          }, 50)
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="32" height="32" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:15px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:11px;">Du kan kun uploade filer som er jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      dropzoneOptions2: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 17,
        acceptedFiles: 'image/*,application/pdf,.doc,.docx,application/msword,.pdf',
        createImageThumbnails: true,
        addRemoveLinks: true,
        renameFile: true,
        complete: function (file) {
          setTimeout(() => {
            this.removeFile(file)
          }, 50)
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="32" height="32" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:15px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:11px;">Du kan kun uploade filer som er pdf, doc, docx, jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      laborAmount: 3,
      expectedLabor: 3,
      expectedBids: 3,
      show: false,
      opgaverhow: false,
      label: 'Loading...',
      overlay: true,
      success: false,
      startDate: '',
      endDate: '',
      config: {
        format: 'LL',
        minDate: new Date(),
        sideBySide: false,
        useCurrent: false,
        debug: true,
        showClear: false,
        showClose: false
      },
      opgave1: '',
      offer1: '3',
      subopgave1: '',
      numofman1: '',
      postnumber1: '',
      startdate1: '',
      duration1: '',
      timepris1: '',
      desc1: '',
      opgaveoptions: [],
      images: [],
      files: [],
      opgaver: [],
      subopgaveoptions: [],
      validationErrors: {
        opgave1: null,
        subopgave1: null,
        numofman1: null,
        postnumber1: null,
        startdate1: null,
        duration1: null,
        timepris1: null,
        desc1: null,
        opgave2: null,
        numofman2: null,
        postnumber2: null,
        startdate2: null,
        timepris2: null,
        desc2: null
      },
      toolsIncluded: '',
      vehicleIncluded: ''
      // apikey: '',
      // apikeye: '',
      // apikeyb: '',
      // facebookpageid: '',
      // help: '',
      // pdf: '',
      // dineroShow: false,
      // facebookShow: true,
      // facebookShowbox: true,
      // items: [],
      // loginOption: { scope: 'email,manage_pages,publish_pages' },
      // optionsDistance: [],
      // firmaid: '',
      // partnertype: 'SMS-partner',
      // dineroapiupdate: '',
      // economicapiupdate: '',
      // billyapiupdate: '',
      // facebookapiupdate: '',
      // show: false,
      // imentor: true,
      // label: 'Loading...',
      // overlay: 1,
      // haaId: '',
      // salesPerson: ''
    }
  },
  mounted: {
    // readMore () {
    //   var dots = document.getElementById('dots')
    //   var moreText = document.getElementById('more')
    //   var btnText = document.getElementById('moreBtn')
    //   if (dots.style.display === 'none') {
    //     dots.style.display = 'inline'
    //     btnText.innerHTML = 'Read more'
    //     moreText.style.display = 'none'
    //   } else {
    //     dots.style.display = 'none'
    //     btnText.innerHTML = 'Read less'
    //     moreText.style.display = 'inline'
    //   }
    // }
    // facebookState () {
    //   return this.facebookpageid.length > 10
    // }
  },
  components: {
    // Imentor,
    // VFacebookLogin,
    Haandvaerker,
    Dropzone,
    vSelect,
    datePicker,
    // hotlinemodal,
    // archivemodal,
    loading,
    Simplert,
    noneligibleFeaturepop
  },
  created () {
    this.eligible = localStorage.getItem('PartnerloginMesterMesterPost')
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.Reload()
    // if (localStorage.getItem('imentor') === '0') {
    //   this.imentor = false
    // }
  },
  watch: {
    // whenever question changes, this function will run
    opgave1: function (newSearchvalue, oldSearchvalue) {
      if (newSearchvalue !== null) {
        this.change1()
      }
    }
  },
  methods: {
    getdataigibility (clicktype = 'yes') {
      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'PartnerloginMesterMesterPost')
      } else {
        if (clicktype === 'yes') {
          this.onSubmit()
        }
      }
    },
    onSubmit () {
      if (this.validateForm1()) {
        this.show = true
        this.salesPerson = localStorage.getItem('id_token_portal')
        var dataPartner = {opgave1: this.opgave1.value, subopgave1: this.subopgave1.value, numofman1: this.numofman1, offer1: this.offer1, postnumber1: this.postnumber1, startdate1: this.startdate1, duration1: this.duration1, timepris1: this.timepris1, desc1: this.desc1, images: JSON.stringify(this.images), files: JSON.stringify(this.files)}
        this.$http.post('https://www.kundematch.dk/crm/libraries/productform/product.php?mode=savepartnerjob&json=no&short=' + this.shorturl, dataPartner, { emulateJSON: true })
          .then(
            response => {
              var res = response.body
              this.show = false
              this.loading = false
              if (res.login === false) {
                this.$router.push('/login')
              }
              if (res.success) {
                let obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
                this.success = true
                this.opgave2 = ''
                this.numofman2 = ''
                this.postnumber2 = ''
                this.startdate2 = ''
                this.timepris2 = ''
                this.desc2 = ''
                document.getElementById('setOpgave').click()
                this.Reload()
              } else {
                this.show = false
                alert(res.message)
              }
            },
            response => {
              alert('error')
            }
          )
      } else {
        alert('Kontroller felterne!')
      }
    },
    aflyseOpgave (id) {
      let confirmFn = function () {
        this.$parent.aflyseconfirm_opgave(id)
      }
      let obj = {
        title: 'Bekræft',
        message: 'Er du sikker på at du vil slette denne opgave ?',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Bekræft',
        customConfirmBtnClass: 'simplert__confirm bg-success',
        customCloseBtnClass: 'simplert__close bg-secondary',
        customCloseBtnText: 'Luk',
        showXclose: true
      }
      this.$refs.simplert.openSimplert(obj)
    },
    aflyseconfirm_opgave (id) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'aflyseconfirm_opgave', salesPerson: this.salesPerson, opgaveid: id}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    OpenUrl (url) {
      this.$router.push(url)
      this.$refs.findworkModal.hide()
    },
    change1 () {
      this.opgaverhow = true
      this.subopgave1 = ''
      this.subopgaveoptions = this.opgave1.suproduct
    },
    validateForm1 () {
      var success = true
      if (this.opgave1 === '') {
        this.validationErrors.opgave1 = true
        success = false
      }
      if (this.subopgave1 === '') {
        this.validationErrors.subopgave1 = true
        success = false
      }
      if (this.numofman1 === '') {
        this.validationErrors.numofman1 = true
        success = false
      }
      if (this.postnumber1 === '') {
        this.validationErrors.postnumber1 = true
        success = false
      }
      if (this.startdate1 === '') {
        this.validationErrors.startdate1 = true
        success = false
      }
      if (this.duration1 === '') {
        this.validationErrors.duration1 = true
        success = false
      }
      if (this.timepris1 === '') {
        // this.validationErrors.timepris1 = true
        // success = false
      }
      if (this.desc1 === '') {
        this.validationErrors.desc1 = true
        success = false
      }
      return success
    },
    updateValue (event) {
      const value = event.target.value
      console.log(value, this.laborAmount)
      if (String(value).length <= 10) {
        this.laborAmount = value
      }
      this.$forceUpdate()
    },
    sendingEvent (file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      formData.append('salesPerson', this.salesPerson)
      formData.append('levid', this.haaId)
      formData.append('operation', 'uploadImagesMester')
    },
    'showSuccess': function (file) {
      this.images.push(file.xhr.response)
    },
    'showSuccess2': function (file) {
      this.files.push(file.xhr.response)
    },
    RemoveUrl (file) {
      var item = file.split('/').pop()
      return item
    },
    hideModal () {
      this.$refs.reviewModal.hide()
    },
    hideLaborModal () {
      this.$refs.reviewLaborForm.hide()
    },
    delete_image (image) {
      const index = this.images.indexOf(image)
      if (index > -1) {
        this.images.splice(index, 1)
      }
    },
    delete_file (file) {
      const index = this.files.indexOf(file)
      if (index > -1) {
        this.files.splice(index, 1)
      }
    },
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'oversigt_partner_profil_mester', salesPerson: this.salesPerson, typeMeeting: '1'}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            this.show = false
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.opgaveoptions = res.productmester
            this.shorturl = res.urlshort
            this.opgaver = res.opgave
          },
          response => {
            this.show = false
            alert('error')
          }
        )
    },
    readMore () {
      var dots = document.getElementById('dots')
      var moreText = document.getElementById('more')
      var btnText = document.getElementById('btnText')
      var moreIcon = document.getElementById('moreIcon')
      var lessIcon = document.getElementById('lessIcon')
      if (dots.style.display === 'none') {
        dots.style.display = 'inline'
        btnText.innerHTML = 'Læs mere'
        moreText.style.display = 'none'
        moreIcon.style.display = 'inline'
        lessIcon.style.display = 'none'
      } else {
        dots.style.display = 'none'
        btnText.innerHTML = 'Luk'
        moreText.style.display = 'block'
        moreIcon.style.display = 'none'
        lessIcon.style.display = 'inline'
      }
    }
    // Reload () {
    //   this.salesPerson = localStorage.getItem('id_token_portal')
    //   this.haaId = localStorage.getItem('haaid')
    //   var dataPartner = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1'}
    //   this.$http.post('', dataPartner, { emulateJSON: true })
    //     .then(
    //       response => {
    //         var res = response.body
    //         if (res.login === false) {
    //           this.$router.push('/login')
    //         }
    //         this.service_reminder = res.service_reminder
    //         this.partnertype = res.partnertype
    //         this.autobooking = res.autobooking
    //         this.inactivesms = res.inactivesms
    //         this.sms_size = res.sms_size
    //         this.dineroapiupdate = res.dineroapiupdate
    //         this.economicapiupdate = res.economicapiupdate
    //         this.billyapiupdate = res.billyapiupdate
    //         this.facebookapiupdate = res.facebookapiupdate
    //         this.firmaid = res.dinerofirma
    //         this.apikey = res.dineroapi
    //         this.apikeye = res.economicapi
    //         this.apikeyb = res.billyapi
    //         this.facebookpageid = res.facebookapi
    //       },
    //       response => {
    //         alert('error')
    //       }
    //     )
    // },
    // getUserData (log) {
    //   console.log(log)
    //   if (log['authResponse']['accessToken']) {
    //     this.show = true
    //     this.salesPerson = localStorage.getItem('id_token_portal')
    //     var dataPartner = {operation: 'service_facebook', salesPerson: this.salesPerson, token: log['authResponse']['accessToken'], userid: log['authResponse']['userID'], expire: log['authResponse']['data_access_expiration_time'], levid: this.haaId}
    //     this.$http.post('', dataPartner, { emulateJSON: true })
    //       .then(
    //         response => {
    //           var res = response.body
    //           this.show = false
    //           if (res.login === false) {
    //             this.$router.push('/login')
    //           }
    //           if (res.success) {
    //             this.modalShowDato = false
    //             let obj = {
    //               title: 'Gennemført!',
    //               message: '',
    //               type: 'success'
    //             }
    //             this.$refs.simplert.openSimplert(obj)
    //             this.Reload()
    //           } else {
    //             alert(res.message)
    //           }
    //         },
    //         response => {
    //           alert('error')
    //         }
    //       )
    //   }
    // },
    // getConnectData (log) {
    //   this.facebookShow = true
    // },
    // service_dinero () {
    //   this.show = true
    //   this.salesPerson = localStorage.getItem('id_token_portal')
    //   var dataPartner = {operation: 'service_dinero', salesPerson: this.salesPerson, firmaid: this.firmaid, apikey: this.apikey, levid: this.haaId}
    //   this.$http.post('', dataPartner, { emulateJSON: true })
    //     .then(
    //       response => {
    //         var res = response.body
    //         this.show = false
    //         if (res.login === false) {
    //           this.$router.push('/login')
    //         }
    //         if (res.success) {
    //           this.modalShowDato = false
    //           let obj = {
    //             title: 'Gennemført!',
    //             message: '',
    //             type: 'success'
    //           }
    //           this.$refs.simplert.openSimplert(obj)
    //           this.Reload()
    //         } else {
    //           alert(res.message)
    //         }
    //       },
    //       response => {
    //         alert('error')
    //       }
    //     )
    // },
    // service_economic () {
    //   this.show = true
    //   this.salesPerson = localStorage.getItem('id_token_portal')
    //   var dataPartner = {operation: 'service_economic', salesPerson: this.salesPerson, apikeye: this.apikeye, levid: this.haaId}
    //   this.$http.post('', dataPartner, { emulateJSON: true })
    //     .then(
    //       response => {
    //         var res = response.body
    //         this.show = false
    //         if (res.login === false) {
    //           this.$router.push('/login')
    //         }
    //         if (res.success) {
    //           this.modalShowDato = false
    //           let obj = {
    //             title: 'Gennemført!',
    //             message: '',
    //             type: 'success'
    //           }
    //           this.$refs.simplert.openSimplert(obj)
    //           this.Reload()
    //         } else {
    //           alert(res.message)
    //         }
    //       },
    //       response => {
    //         alert('error')
    //       }
    //     )
    // },
    // service_billy () {
    //   this.show = true
    //   this.salesPerson = localStorage.getItem('id_token_portal')
    //   var dataPartner = {operation: 'service_billy', salesPerson: this.salesPerson, apikeyb: this.apikeyb, levid: this.haaId}
    //   this.$http.post('', dataPartner, { emulateJSON: true })
    //     .then(
    //       response => {
    //         var res = response.body
    //         this.show = false
    //         if (res.login === false) {
    //           this.$router.push('/login')
    //         }
    //         if (res.success) {
    //           this.modalShowDato = false
    //           let obj = {
    //             title: 'Gennemført!',
    //             message: '',
    //             type: 'success'
    //           }
    //           this.$refs.simplert.openSimplert(obj)
    //           this.Reload()
    //         } else {
    //           alert(res.message)
    //         }
    //       },
    //       response => {
    //         alert('error')
    //       }
    //     )
    // },
    // hideModal () {
    //   this.$refs.dinerowModal.hide()
    // },
    // showModal (pdf) {
    //   this.pdf = pdf
    //   this.$refs.dinerowModal.show()
    // }
  }
}
</script>
<style lang="less">
#more {display: none;}
.vue-dropzone {
  width:100%;
  padding: 0;
  border: 0;
  background: white;
  &:hover {
    background: white!important;
  }
}
.dz-preview {
  display: none!important;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.searchContainer {
  position: relative;
  overflow: hidden;
}
.searchIcon {
  padding: 0.5rem;
}
.text-danger {
  color: red;
  background: #FDD;
  padding: 2px;
}
.searchBox {
  border: 0;
  flex: 1;
  outline:none;
}
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgba(47, 54, 64, 0.5);
}
::-moz-placeholder { /* Firefox 19+ */
  color: rgba(47, 54, 64, 0.5);
}
:-ms-input-placeholder { /* IE 10+ */
  color: rgba(47, 54, 64, 0.5);
}
:-moz-placeholder { /* Firefox 18- */
  color: rgba(47, 54, 64, 0.5);
}
.white-border {
  border-color: white!important;
}
</style>



// WEBPACK FOOTER //
// MesterOpgaver.vue?e20325ba